










































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IWorkflowForSelection } from '@/api/types/response.types'
import { IStatusMapping } from '@/api/types/request.types'

/* API */

export default Vue.extend({
  name: 'ChangeWorkflowModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    currentWorkflow: {
      type: Object as () => IWorkflowForSelection,
      required: true,
    },
    newWorkflow: {
      type: Object as () => IWorkflowForSelection,
      default: null,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    autoMapStatuses: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isSubmitting: false,
      statusMappings: [] as IStatusMapping[],
    }
  },

  computed: {
    internalShowModal: {
      get(): boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    submitBtnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
    itemPluralName(): string {
      return TextAssistant.itemPluralName(this.entityType).toLowerCase()
    },
    entitySingularName(): string {
      return TextAssistant.entitySingularName(this.entityType).toLowerCase()
    },
    subtitle(): string {
      if (this.workflowsLoaded) {
        return `<i class='ddi ddi-workflows'></i>&nbsp;&nbsp;${
          this.currentWorkflow.name
        }&nbsp;&nbsp;<i class='ddi ddi-arrow-right'></i>&nbsp;&nbsp;<i class='ddi ddi-workflows'></i>&nbsp;&nbsp;${
          this.newWorkflow.name
        } `
      }
      return ''
    },
    workflowsLoaded(): boolean {
      if (this.currentWorkflow && this.newWorkflow) {
        return true
      }
      return false
    },
    allStatusesMapped(): boolean {
      return (
        this.statusMappings.length > 0 &&
        this.statusMappings.filter(m => m.newStatusID === null).length === 0
      )
    },
    submitBtnText(): string {
      return this.autoMapStatuses
        ? 'Change workflow'
        : 'Change workflow & update all statuses'
    },
  },

  watch: {
    showModal: {
      handler(newVal: boolean) {
        if (newVal) {
          this.isSubmitting = false

          // Hydrate status mappings if we are auto-mapping (and not needing the entity-workflow-status-mapper)
          if (this.autoMapStatuses) {
            this.statusMappings = [] as IStatusMapping[]
            this.currentWorkflow.listStatuses.forEach(c => {
              this.statusMappings.push({
                oldStatusID: c.id,
                newStatusID: this.newWorkflow.listStatuses[0].id,
              })
            })
          }
        }
      },
    },
  },

  methods: {
    closeModal() {
      this.internalShowModal = false
    },
    changeWorkflow() {
      this.$emit('statuses-mapped', this.statusMappings)
      this.isSubmitting = true
    },
  },
})
